import {SIGN_UP_OPTION, START_UP_GUIDE_OPTION} from "./DataFlowTypes"

type OnBoardingDataFlowAttributes = {
    completedGuides: Array<START_UP_GUIDE_OPTION>
    signUpSurveySelection: Array<SIGN_UP_OPTION>
    startUpGuideSurveySelection: Array<START_UP_GUIDE_OPTION>
}

export type DataFlowDto = {
    id: string,
    type: string,
    attributes: OnBoardingDataFlowAttributes
}

export default class DataFlow {
    private dto: DataFlowDto
    constructor(dto: DataFlowDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "onboarding-data-flow"
    }

    getId(): string {
        return this.dto.id
    }

    getSignUpSurveySelection(){
        return this.dto.attributes.signUpSurveySelection || []
    }

    getStartUpGuideSurveySelection(){
        return this.dto.attributes.startUpGuideSurveySelection || []
    }

    getCompletedGuides(){
        return this.dto.attributes.completedGuides || []
    }

}


// WEBPACK FOOTER //
// ./src/state/onboarding/DataFlow.ts